import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { IRouteDetails } from "../models/IRouteDetails";
import { IRouteMapRequest } from "../models/IRouteMapRequest";
import { ResumeRouteMapDTO } from "../models/ResumeRouteMapDTO";
import { StepDetailsRouteDTO } from "../models/StepDetailsRouteDTO";
import { GroupStepRouteDTO } from "../models/GroupStepRouteDTO";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PanelResumeRouteService {
  
  private id$: Subject<string> = new Subject<string>();
  private resume$: Subject<ResumeRouteMapDTO> = new Subject<ResumeRouteMapDTO>();
  private Data$: Subject<IRouteDetails> = new Subject<IRouteDetails>();
  private request$: Subject<IRouteMapRequest> = new Subject<IRouteMapRequest>();
  private details$: Subject<StepDetailsRouteDTO[]> = new Subject<StepDetailsRouteDTO[]>();
  public StepDetailsRouteDTO: any;
  isVisibleDetails$: Subject<boolean> = new Subject<boolean>();
  groupStepsRouteDTO: GroupStepRouteDTO[];
  resumeRouteMapDTO: ResumeRouteMapDTO;

  public isVisible = false;

  constructor() {
  
  }

  getData(): Observable<IRouteDetails> {
    return this.Data$.asObservable();
  }
  setData(data: any) {
    if(!environment.production) console.log("SETDATA");
    this.Data$.next(data);
    // var arrayMaster = Object.entries(properties);
    // this.keys = [];
    // this.values = [];
    // arrayMaster.forEach((element) => {
    //   if(!environment.production) console.log(element);
    //   var array = element.slice();
    //   var iterator = array.values();
    //   if(iterator.next().value!=null && iterator.next().value!=undefined){
    //   this.keys.push(iterator.next().value.toString());
    //   this.values.push(iterator.next().value.toString());}
    // });

  }
  getResume(): Observable<ResumeRouteMapDTO> {
    return this.resume$.asObservable();
  }

  getDetails(): Observable<StepDetailsRouteDTO[]> {
    return this.details$.asObservable();
  }
  setDetails(details: StepDetailsRouteDTO[]) {
    this.StepDetailsRouteDTO = details;
  }

  setGrouped(grouped: GroupStepRouteDTO[]) {
    this.groupStepsRouteDTO = grouped;
  }

  setTitle(Id: string) {
    this.id$.next(Id);
  }
 
  getTitle() {
    return this.id$.asObservable();
  }

  setRequest(request: IRouteMapRequest) {
    this.request$.next(request);
  }

  getRequest() : Observable<IRouteMapRequest> {
    return this.request$.asObservable();
  }

  setResume(resume: ResumeRouteMapDTO) {
    this.resumeRouteMapDTO = resume;
    this.resume$.next(resume);
    // var arrayMaster = Object.entries(properties);
    // this.keys = [];
    // this.values = [];
    // arrayMaster.forEach((element) => {
    //   if(!environment.production) console.log(element);
    //   var array = element.slice();
    //   var iterator = array.values();
    //   if(iterator.next().value!=null && iterator.next().value!=undefined){
    //   this.keys.push(iterator.next().value.toString());
    //   this.values.push(iterator.next().value.toString());}
    // });

  }
  checkVisibilityPopup(): Observable<boolean> {
    return this.isVisibleDetails$.asObservable();
  }
  setVisibilityPopup(op) {
    this.isVisible = op;
    this.isVisibleDetails$.next(op);
  }

}
